import { Component } from '@angular/core';
import { CommonService } from './core/services/common.service';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Component({
  selector: 'bt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'brand-tarinha';
  constructor(
    public commonService: CommonService,
    private router: Router
  ) {
    this.setGlobalLoaddingChangeRoute();
  }
  setGlobalLoaddingChangeRoute() {
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        this.commonService.changeStateLodding(true);
      }
      if (event instanceof NavigationEnd) {
        this.commonService.changeStateLodding(false);
      }

      // Set loading state to false; in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
        this.commonService.changeStateLodding(false);
      }
      if (event instanceof NavigationError) {
        this.commonService.changeStateLodding(false);
      }
    });
  }
}
